import React from 'react'
import { sektorlerData } from '../data/sektorler-data'
import { Link, useParams } from 'react-router'

import { motion } from 'framer-motion';
import { containerVariants, itemVariants, textVariants, container, child, imageVariants } from '../script/animation';

const Sektorler = () => {

    const { id1 } = useParams()
    const sektor = sektorlerData.find((category) => category.link === id1);

    
    return (
        <div className="w-full bg-red grid grid-cols-11 relative  calc-height content-start">


            <div className=' col-start-2 col-span-9  w-full text-16 text-customGold1 text-opacity-55 py-10'>
                <Link to={'/'}>Anasayfa / </Link>
                <Link to={'/sektorler/otomobil'}>Sektörler / </Link>
                <Link to={`/sektorler/${id1}`}>{`${sektor.name}`}</Link>

            </div>

            <div className="col-start-2 col-span-9 lg:col-start-2 lg:col-span-8 z-50 pb-20   grid grid-cols-5">







                <motion.div variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    className='col-span-5 md:col-span-1   pr-10 mb-10 md:mb-0'>
                    {
                        sektorlerData.map((item, index) => {
                            return (
                                <motion.div variants={itemVariants} key={index}> <Link to={`/sektorler/${item.link}`} className='block'><h5 className={`text-18  font-semibold  border-opacity-50 ${id1 === item.link ? 'border-b-black' : 'border-b-customGold1'}     ${id1 === item.link ? 'text-black' : 'text-customGold1'} border-b py-2`}>{item.name}</h5></Link></motion.div>
                            )
                        })
                    }
                </motion.div>


                <motion.div variants={containerVariants}
                                    initial="hidden"
                                    animate="visible" 
                                    exit="exit"
                                    
                                    className='col-span-5 md:col-span-4  overflow-hidden  '>
                    {/* <h2 className='mb-3'>{sektor?.name}</h2> */}
                    <div className='space-y-5 '>
                        {
                            sektor.text.map((item, index) => {
                                return (
                                 <motion.p variants={textVariants} key={index} className='text-18 text-customGray'>{item}</motion.p>
                                )
                            })
                        }
                    </div>
                    <motion.div variants={imageVariants} className='h-[35vh] w-full overflow-hidden '>
                        <motion.img src={`/images/sektorler/${id1}/0.jpg`} className='h-full w-full object-cover mt-5' />
                    </motion.div>
                </motion.div>


            </div>

        </div>
    )
}

export default Sektorler